(function () {
    'use strict';

    angular
        .module('elogbooksControllers')
        .controller('SiteAccessConfirmationModalController', SiteAccessConfirmationModalController);

    SiteAccessConfirmationModalController.$inject = ['config', '$uibModalInstance', '$rootScope'];

    function SiteAccessConfirmationModalController (config, $uibModalInstance, $rootScope) {
        var vm = this;
        vm.config = config;
        vm.showSitesList = false;

        if(!vm.config.forceDirtyConfirm) {
            $rootScope.skipDirtyCheck = true;
        }

        vm.toggleSitesList = function() {
            vm.showSitesList = !vm.showSitesList;
        };

        vm.close = function () {
            $rootScope.skipDirtyCheck = false;
            $uibModalInstance.dismiss();
        };

        vm.confirm = function () {
            $uibModalInstance.close({result: true});
        };
    };
})();
